import html2canvas from "html2canvas";

export async function capturePreview(elm: HTMLElement): Promise<string> {
    const target_width = 300;
    const target_height = 200;

    let width = elm.clientWidth;
    let target_ratio = target_width / width;
    let height = target_height * width / target_width;
    if (elm.clientHeight < height * 0.8) { // 横長で 下部に余白ができすぎる場合の調整
        width = elm.clientWidth * (elm.clientHeight / height);
        target_ratio = target_width / width;
        height = target_height * width / target_width;
    }

    const canvas = await html2canvas(elm, {scale: target_ratio, width: width, height: height});
    return canvas.toDataURL('image/jpg');
}
